var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenderFemale = function SvgIconGenderFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.75 9A7.75 7.75 0 0 1 13 16.686V18.5h2.75a1 1 0 1 1 0 2H13v2a1 1 0 1 1-2 0v-2H8.25a1 1 0 1 1 0-2H11v-1.814A7.751 7.751 0 0 1 12 1.25 7.75 7.75 0 0 1 19.75 9M12 3.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconGenderFemale;